import { useEffect, useState } from 'react'

import { $isUserGamedPremium, $userLanguage, $userToken } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { $isSteamDataLoading } from '@/entities/platforms/steam/store'
import { useUnit } from 'effector-react'
import { goToProfile, goOnPrivateError } from '@/app/routing/events'
import { useHideNav } from '@/shared/hooks/useHideNav'

import { getUserProfileFx } from '@/entities/user'
import { SteamUserDataType } from '@/entities/user'
import { ListObjectType } from '../types'

import { ProfileCard } from '@/features/profileCard'
import { CoinIcon } from '@/shared/ui/icons'
import { AppButton } from '@/shared/ui/button'
import { usePostStory } from '@/shared/hooks/usePostStory'
import { useStyles } from './styles'
import { ItemsList } from '@/features/profileTabs/itemsList'
import { AccStatsList } from '@/features/accStatsList'
import { lang } from '@/shared/constants/lang'
import Break from '@/shared/ui/break'
import { Firework } from '@/shared/ui/firework'
import { formatNumber } from '@/shared/util/formatNumber'
import ButtonWrapper from '@/shared/ui/buttonWrapper'

type InitialScoreProps = {
  onClick: () => void
}

export const InitialScore = (props: InitialScoreProps) => {
  useHideNav()

  const storedSteamData = useUnit($steamUserData)
  const userLang = useUnit($userLanguage)
  const isPlusUser = useUnit($isUserGamedPremium)
  const isLoading = useUnit($isSteamDataLoading)
  const userToken = useUnit($userToken)
  const { classes } = useStyles()
  const [steamUserData, setSteamUserData] = useState<SteamUserDataType | null>(null)
  const [fireworkFlag, setFirewokFlag] = useState<boolean>(false)
  const [isShowingFirework, setIsShowingFirework] = useState<boolean>(false)
  const [totalGamedValue, setTotalGamedValue] = useState<string | null>(null)
  const [accountStats, setAccountStats] = useState<ListObjectType[] | null>(null)

  const { canShareStory, handleShareStory, isMakingStoryLink } = usePostStory()

  const texts = lang[userLang].pages.updatePage
  const units = lang[userLang].pages.units
  const btnTexts = lang[userLang].pages.btnTexts

  // const [shouldPoll, setShouldPoll] = useState(true)

  useEffect(() => {
    // if (steamUserData?.userData !== null) {
    //   setShouldPoll(false)
    //   return
    // }

    if (userToken !== null && isLoading) {
      getUserProfileFx(userToken)
    } else if (storedSteamData != null && storedSteamData.userData.profile_private === true) {
      goOnPrivateError()
    } else if (!isLoading) {
      // таймаут ставится потому что есть баг с получением апдейта итемов.
      // ждем 7 сек - если не пришло - игнорируем список итемов.
      // надо фиксить со стороны бека
      setTimeout(() => {
        setSteamUserData(storedSteamData)
      }, 7000)
    }
  }, [storedSteamData, isLoading, userToken])

  useEffect(() => {
    if (steamUserData !== null && !fireworkFlag) {
      setIsShowingFirework(true)
      setFirewokFlag(true) // to trigger it only once
      setTimeout(() => {
        setIsShowingFirework(false)
      }, 4000)
    }
  }, [steamUserData, fireworkFlag])

  useEffect(() => {
    if (steamUserData?.userData.tokenValue) {
      setTotalGamedValue(formatNumber(steamUserData.userData.tokenValue) as string)
    }

    return setAccountStats([
      {
        name: texts.games_owned,
        value: steamUserData?.userData!.gamesOwned,
      },
      {
        name: texts.items_owned,
        value: steamUserData?.userData!.itemsOwned,
      },
      {
        name: texts.total_playtime,
        value: steamUserData?.userData!.totalHoursPlayed,
        unit: units.hours,
      },
      {
        name: texts.account_value,
        value: steamUserData?.userData.totalValue ? '$ ' + steamUserData?.userData.totalValue : null,
      },
      {
        name: texts.inventory_price,
        value: steamUserData?.userData.inventoryPrice ? '$ ' + steamUserData?.userData.inventoryPrice : null,
        isPlus: true,
      },
      {
        name: texts.account_age,
        value: steamUserData?.userData.accountAge,
        isPlus: true,
        unit: ` ${units.years}`,
      },
    ])
  }, [steamUserData, texts, units])

  return (
    <>
      <Firework isVisible={isShowingFirework} />
      <div className={classes.root}>
        <ProfileCard variant="standard" />
        <div className={classes.content}>
          <div
            data-isloading={isLoading}
            className={classes.title}
          >
            {texts.total_value}
          </div>
          {totalGamedValue && (
            <div className={classes.totalValue}>
              + {totalGamedValue} <CoinIcon />
            </div>
          )}
          {!totalGamedValue && <div className={classes.calculating}>{texts.calculating}</div>}
        </div>
        <AccStatsList
          propValue={accountStats!}
          isPlusUser={isPlusUser}
        />
        <Break width="100%" />
        <p className={classes.listTitle}>{texts.most_expensive}</p>
        <ItemsList itemsList={steamUserData ? steamUserData.itemsList : null} />
        <ButtonWrapper
          style={{
            flexDirection: 'row',
            paddingLeft: '5%',
            paddingRight: '5%',
            width: '100%',
            zIndex: 99,
          }}
        >
          <AppButton
            variant="storiesReward"
            size="large"
            fullWidth={true}
            onClick={handleShareStory}
            isLoading={isMakingStoryLink}
            disabled={!canShareStory || !totalGamedValue}
          >
            {btnTexts.share2}
          </AppButton>
          <AppButton
            onClick={() => {
              if (props.onClick) {
                props.onClick()
              }
              goToProfile()
            }}
            disabled={!totalGamedValue}
            sx={{ height: '52px' }}
            fullWidth
          >
            {btnTexts.profile}
          </AppButton>
        </ButtonWrapper>
      </div>
    </>
  )
}
